/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Serve_Step3_DescInputs */

const en_serve_step3_desc = /** @type {(inputs: Serve_Step3_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Paste this command in the same window. A link appears — open it, sign in, and leave the window open. That is it: from now on Bystep sends the steps to this computer.`)
};

const id_serve_step3_desc = /** @type {(inputs: Serve_Step3_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tempel perintah ini di jendela yang sama. Akan muncul tautan — buka, masuk, dan biarkan jendelanya terbuka. Selesai: mulai sekarang Bystep mengirim langkah ke komputer ini.`)
};

/**
* | output |
* | --- |
* | "Paste this command in the same window. A link appears — open it, sign in, and leave the window open. That is it: from now on Bystep sends the steps to this c..." |
*
* @param {Serve_Step3_DescInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const serve_step3_desc = /** @type {((inputs?: Serve_Step3_DescInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Serve_Step3_DescInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_serve_step3_desc(inputs)
	return en_serve_step3_desc(inputs)
});